import { createOrganization, getOrganization, updateOrganization } from './organization'
import { API } from 'aws-amplify'

export default {
  organization: {
    createOrganization,
    getOrganization,
    updateOrganization,
  },
  getStarredTendersIds() {
    const query = `query {
      myStarredItems {
        data {
          id
        }
      }
    }`;

    return API.graphql({
      query,
      variables: {},
    })
  }
}
